import type { Coupon, CreatedPass } from '../types';
import { api } from './api';

export const CouponApi = api.injectEndpoints({
  endpoints: (builder) => ({
    listCoupons: builder.query<Coupon[], void>({
      query: () => `/templates/coupons/`,
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ id }) => ({ type: 'Coupons' as const, id })),
              { type: 'Coupons', id: 'LIST' },
            ]
          : [{ type: 'Coupons', id: 'LIST' }],
    }),
    createCoupon: builder.mutation<Coupon, {}>({
      query: (data: object) => ({
        url: `/templates/coupons/`,
        method: 'POST',
        headers: {
          'content-type': 'application/json',
        },
        body: JSON.stringify(data),
      }),
      invalidatesTags: [{ type: 'Coupons', id: 'LIST' }],
    }),
    retrieveCoupon: builder.query<Coupon, string>({
      query: (id) => `/templates/coupons/${id}/`,
      providesTags: (result, error, id) => [{ type: 'Coupons', id }],
    }),
    deleteCoupon: builder.mutation<Coupon, string>({
      query: (id) => ({
        url: `/templates/coupons/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: (res, err, id) => [{ type: 'Coupons', id }, { type: 'Coupons', id: 'LIST' }],
    }),
    patchCoupon: builder.mutation<Coupon, {id: string, updatedPassTemplate: object}>({
      query: (data) => ({
        url: `/templates/coupons/${data.id}/`,
        method: 'PATCH',
        headers: {
          'content-type': 'application/json',
        },
        body: JSON.stringify(data.updatedPassTemplate),
      }),
      invalidatesTags: (res, err, data) => [{ type: 'Coupons', id: data.id }, { type: 'Coupons', id: 'LIST' }],
    }),
    generateCouponPass: builder.mutation<CreatedPass, {id: string, fieldsData: object}>({
      query: (data) => ({
        url: `/templates/coupons/${data.id}/create_pass/`,
        method: 'POST',
        headers: {
          'content-type': 'application/json',
        },
        body: JSON.stringify(data.fieldsData),
      }),
      invalidatesTags: (res, err, data) => [{ type: 'Coupons', id: data.id }, { type: 'Coupons', id: 'LIST' }],
    }),
    updateCouponPass: builder.mutation<CreatedPass, {id: string, fieldsData: object}>({
      query: (data) => ({
        url: `/templates/coupons/${data.id}/update_pass/`,
        method: 'POST',
        headers: {
          'content-type': 'application/json',
        },
        body: JSON.stringify(data.fieldsData),
      }),
      invalidatesTags: (res, err, data) => [{ type: 'Coupons', id: data.id }, { type: 'Coupons', id: 'LIST' }],
    }),
    deleteCouponPass: builder.mutation<Coupon, {templateId: string, passId: string}>({
      query: (data) => ({
        url: `/templates/coupons/${data.templateId}/delete_pass/`,
        method: 'DELETE',
        headers: {
          'content-type': 'application/json',
        },
        body: JSON.stringify({"pass_id": data.passId}),
      }),
      invalidatesTags: (res, err, data) => [{ type: 'Coupons', id: data.templateId }, { type: 'Coupons', id: 'LIST' }],
    }),
    sendCouponPassPush: builder.mutation<Coupon, {templateId: string, passId: string, message: string}>({
      query: (data) => ({
        url: `/templates/coupons/${data.templateId}/send_push/`,
        method: 'POST',
        headers: {
          'content-type': 'application/json',
        },
        body: JSON.stringify({"pass_id": data.passId, "message": data.message}),
      }),
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useListCouponsQuery, useCreateCouponMutation, useRetrieveCouponQuery, useDeleteCouponMutation, usePatchCouponMutation,
  useGenerateCouponPassMutation, useUpdateCouponPassMutation, useDeleteCouponPassMutation, useSendCouponPassPushMutation } = CouponApi